import { getProductJson } from './helpers';
import { nostoRecommendedVariantViewEvent } from '../../components/nosto/events';
import { clickColorSwatch, selectSize } from './selectVariant';

export default class Fits {
  section;
  elements;
  plus_size_prefix_name;
  selected_fit;
  product_json;

  constructor() {
    this.plus_size_prefix_name = 'Plus Size';
    this.product_json = getProductJson();

    this.section = (document.querySelector('[data-product-overview].product-overview-v3')) ? document.querySelector('[data-product-overview].product-overview-v3') : document.querySelector('[data-product-overview].product-overview-v4');

    this.elements = {
      fitOptionContainer: this.section?.querySelector('[data-option-fit]') ?? null,
      fitOptionContainerSticky: document.querySelector('[data-desktop-sticky-add-to-cart-fits]'),
      sizeOptions: this.section?.querySelectorAll('[data-product-option-size]') ?? [],
      standardSizeOptions: this.section?.querySelectorAll('[data-plus-size="false"]') ?? [],
      plusSizeOptions: this.section?.querySelectorAll('[data-plus-size="true"]') ?? [],
      colorOptions: this.section?.querySelectorAll('[data-product-option-color]') ?? [],
      standardSizeColorOptions: this.section?.querySelectorAll('[data-plus-color="false"]:not(.inactive)') ?? [],
      plusSizeColorOptions: this.section?.querySelectorAll('[data-plus-color="true"]:not(.inactive)') ?? [],
      fitOptionButton: this.section?.querySelectorAll('[data-product-option-fit]') ?? [],
    };

    this.selected_fit = (this.elements.standardSizeColorOptions.length > 0) ? 'standard' : 'plus';

    if (this.elements.fitOptionButton.length) {
      Array.from(this.elements.fitOptionButton).forEach((element) => {
        element.addEventListener('click', this.changeFitOption.bind(this));
      });
    }

    // Called after the sticky mobile content has been populated
    document.addEventListener('astr-pdp-sticky-mobile-fits-init', (e) => {
      this.initStickyMobile();
    });

    document.addEventListener('astr-pdp-color-selected', () => {
      // window.setTimeout(() => {
        this.updateStickyMobileColorSizeOptions();
      // }, 1);
    });

    this.init();
  }

  init = () => {
    if (!this.section) {
      console.warn('[PlusSizes] Product overview section not found.');
      return;
    }

    // Show the fit selector when both standard and plus sizes are detected within the size list and color options
    if ((this.elements.standardSizeColorOptions.length > 0 && this.elements.standardSizeOptions.length > 0) && (this.elements.plusSizeColorOptions.length > 0 && this.elements.plusSizeOptions.length > 0) && this.elements.fitOptionContainer) {
      this.elements.fitOptionContainer.classList.add('active');
      this.elements.fitOptionContainerSticky.classList.add('active');
    }

    const url = new URL(window.location.href);
    const selected_color = url.searchParams.get('color');
    const selected_variant_id = Number(url.searchParams.get('variant'));
    // console.log('selected param', selected_color, selected_variant_id);

    // By variant ID
    // /products/blythe-floral-plisse-midi-dress?variant=44849925390513
    if (typeof selected_variant_id !== 'undefined' && selected_variant_id !== null) {
      this.findSelectedFitByVariant(selected_variant_id);
    }

    // Select the default fit option
    // By color
    // /products/blythe-floral-plisse-midi-dress?color=Plus%20Size%20-%20Bright%20floral%20multi
    if (typeof selected_color !== 'undefined' && selected_color !== null) {
      this.findSelectedFitByColor(selected_color);
    }

    // Select the correct fit which will also init the colors and sizes
    const fitOption = this.section.querySelector(`[data-product-option-fit][data-fit-handle="${this.selected_fit}"]`);
    if (fitOption) {
      this.changeFitOption(fitOption);
    } else {
      console.warn(`[PlusSizes] Fit option not found for handle: ${this.selected_fit}`);
    }
  };

  initStickyMobile = () => {
    const container = document.querySelector('[data-mobile-sticky-add-to-cart-main]');

    Array.from(container.querySelectorAll('[data-product-option-fit]')).forEach((element) => {
      element.addEventListener('click', this.changeStickyMobileFitOption.bind(this));
    });

    // this.changeStickyMobileFitOption();
  };

  // Defines selected_fit with standard/plus
  findSelectedFitByVariant = (variant_id) => {
    try {
      // Validate the product JSON and variants
      if (!this.product_json || !Array.isArray(this.product_json.variants)) {
        return false;
      }
  
      const variant = this.product_json.variants.find((variant) => variant.id === variant_id);
  
      if (!variant) {
        return false;
      }
  
      this.selected_fit = variant.title.includes(this.plus_size_prefix_name) ? 'plus' : 'standard';
  
      return true;
    } catch (error) {
      console.error('[PlusSizes] Error in findSelectedFitByVariant:', error);
      return false;
    } 
  };

  // Defines selected_fit with standard/plus
  findSelectedFitByColor = (color_name) => {
    if (typeof color_name === 'string' && color_name) {
      this.selected_fit = color_name.includes(this.plus_size_prefix_name) ? 'plus' : 'standard';
    } else {
      this.selected_fit = 'standard'; // fallback or handle as needed
    }
  };

  // Select the same color for the opposite fit.
  selectColorInOppositeFit = () => {
    const selected_swatch = Array.from(this.elements.colorOptions).find(swatch => swatch.classList.contains('active'));
    if (typeof selected_swatch === 'undefined' || this.elements.plusSizeColorOptions.length === 0) {
      return;
    }
    
    const selected_color_handle = selected_swatch.dataset.colorHandle;
    const new_color_handle =  (this.selected_fit === 'plus') ? `plus-size-${selected_color_handle}` : selected_color_handle.replace('plus-size-', '');
    const new_color_swatch = this.section.querySelector(`[data-color-handle="${new_color_handle}"]`);

    if (new_color_swatch) {
      clickColorSwatch(new_color_swatch);
      return;
    }
    
    // The color doesn't exits in this fit. Select the 1st color
    if (this.selected_fit === 'plus') {
      clickColorSwatch(this.elements.plusSizeColorOptions[0]);
      return;
    }

    clickColorSwatch(this.elements.standardSizeColorOptions[0]);
  };

  changeFitOption = (e) => {
    const item = (e.currentTarget) ? e.currentTarget : e;
    const previous_selected_fit_element = this.section.querySelector('[data-product-option-fit].active');

    // Same option selected
    if (previous_selected_fit_element !== null && item.dataset.fitHandle === previous_selected_fit_element.dataset.fitHandle) {
      return;
    }

    Array.from(this.elements.fitOptionButton).forEach((element) => {
      element.classList.remove('active');
    });

    item.classList.add('active');

    this.selected_fit = item.dataset.fitHandle;

    this.displayFitSizes();
    this.displayFitColors();

    // Exclude behavior from initial fit selection
    if (previous_selected_fit_element !== null) {
      // Timeout needed when we come from the sticky add to cart bar
      window.setTimeout(() => {
        this.selectColorInOppositeFit();

        // Select the 1st size in the list
        const new_sizes = document.querySelectorAll(`[data-product-option-size][data-plus-size="${(this.selected_fit === 'plus')}"]`);
        if (new_sizes.length > 0) {
          selectSize(new_sizes[0]);
        }
      }, 1);
    }
    
    const selected_variant = document.querySelector('[data-product-select]');
    if (selected_variant) {
      nostoRecommendedVariantViewEvent(this.product_json.id, selected_variant.value);
    }

    // Desktop sticky add to cart is init on page load from main-products.js
    // This event call is for the other selection scenarios
    document.dispatchEvent(new Event('astr-pdp-fit-selected'));
  };

  changeStickyMobileFitOption = (e) => {
    const item = (e.currentTarget) ? e.currentTarget : e;
    const container = document.querySelector('[data-mobile-sticky-add-to-cart-main]');
    const previous_selected_fit_element = container.querySelector('[data-product-option-fit].active');

    // Same option selected
    if (previous_selected_fit_element !== null && item.dataset.fitHandle === previous_selected_fit_element.dataset.fitHandle) {
      return;
    }

    Array.from(container.querySelectorAll('[data-product-option-fit]')).forEach((element) => {
      element.classList.remove('active');
    });

    item.classList.add('active');
    const selected_fit = item.dataset.fitHandle;

    // Trigger the fit change on the product overview, which will trigger a custom event astr-pdp-color-selected when completed
    this.changeFitOption(this.elements.fitOptionContainer.querySelector(`[data-fit-handle="${selected_fit}"]`));
  };

  // Match the colors and sizes states from the product overview
  updateStickyMobileColorSizeOptions = () => {
    try {
      const container = document.querySelector('[data-mobile-sticky-add-to-cart-main]');

      if (!container) {
        return;
      }

      if (container.querySelector('[data-product-option-fits]') === null) {
        return;
      }   

      Array.from(this.elements.colorOptions).forEach((element) => {
        const colorHandle = element.dataset.colorHandle;
        const stickyColorElement = container.querySelector(`[data-color-handle="${colorHandle}"]`);

        if (!stickyColorElement) {
          return;
        }

        if (element.classList.contains('active')) {
          stickyColorElement.classList.add('active');
        } else {
          stickyColorElement.classList.remove('active');
        }
  
        if (element.classList.contains('hidden')) {
          stickyColorElement.classList.add('hidden');
        } else {
          stickyColorElement.classList.remove('hidden');
        }
      });

      // Match the sizes states from the product overview
      Array.from(this.elements.sizeOptions).forEach((element) => {
        const sizeHandle = element.dataset.sizeHandle;
        const stickySizeElement = container.querySelector(`[data-size-handle="${sizeHandle}"]`);
  
        if (!stickySizeElement) {
          return;
        }
  
        if (element.parentElement.classList.contains('active')) {
          stickySizeElement.parentElement.classList.add('active');
        } else {
          stickySizeElement.parentElement.classList.remove('active');
        }
  
        if (element.parentElement.classList.contains('hidden')) {
          stickySizeElement.parentElement.classList.add('hidden');
        } else {
          stickySizeElement.parentElement.classList.remove('hidden');
        }
      });
    } catch (error) {
      console.error('[PlusSizes] Error in updateStickyMobileColorSizeOptions:', error);
    }
  };

  // Show/hide colors based on selected Fit
  displayFitColors = () => {
    if (this.selected_fit === 'plus') {
      Array.from(this.elements.standardSizeColorOptions).forEach((element) => {
        element.classList.add('hidden');
      });

      Array.from(this.elements.plusSizeColorOptions).forEach((element) => {
        element.classList.remove('hidden');
      });

      return;
    }

    Array.from(this.elements.standardSizeColorOptions).forEach((element) => {
      element.classList.remove('hidden');
    });

    Array.from(this.elements.plusSizeColorOptions).forEach((element) => {
      element.classList.add('hidden');
    });
  };

  // Show/hide sizes based on selected Fit
  displayFitSizes = () => {
    if (this.selected_fit === 'plus') {
      Array.from(this.elements.standardSizeOptions).forEach((element) => {
        element.parentElement.classList.add('hidden');
        element.classList.add('disabled');
      });

      Array.from(this.elements.plusSizeOptions).forEach((element) => {
        element.parentElement.classList.remove('hidden');
        element.classList.remove('disabled');
      });

      return;
    }

    Array.from(this.elements.standardSizeOptions).forEach((element) => {
      element.parentElement.classList.remove('hidden');
      element.classList.remove('disabled');
    });

    Array.from(this.elements.plusSizeOptions).forEach((element) => {
      element.parentElement.classList.add('hidden');
      element.classList.add('disabled');
    });
  };
}
